/**
 * Theme persistence contract.
 *
 * Duplicated by hand in the inline script in index.html, which has to run
 * before any module loads. Change one and you must change the other.
 */
export const THEME_STORAGE_KEY = 'soh-theme';

/** Attribute on <html> that the stylesheet keys every token off. */
export const THEME_ATTRIBUTE = 'data-theme';

export const COLOR_SCHEME_QUERY = '(prefers-color-scheme: light)';

/**
 * Words on the theme toggle's track. Each sits on the side the bubble is
 * not covering, naming where a click will take you.
 */
export const THEME_LABELS = { light: 'Light', dark: 'Dark' } as const;
